import React from 'react';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';
import { useThemeMode } from '../../../../contexts/ThemeProvider';

interface TopLogoProps {
 logo?: string;
 universityName?: string;
}

const TopLogo: React.FC<TopLogoProps> = ({ logo, universityName }) => {
 const { mode } = useThemeMode();
 const isDark = mode === 'dark';

 return (
   <motion.div
     initial={{ opacity: 0, y: -20 }}
     animate={{ opacity: 1, y: 0 }}
     transition={{ duration: 0.8, delay: 0.1, ease: "easeOut" }}
     style={{
       position: 'absolute',
       top: 0,
       left: 0,
       right: 0,
       zIndex: 1001,
       pointerEvents: 'none'
     }}
   >
     <Box
       sx={{
         position: 'absolute',
         top: { xs: 40, md: 35 },
         left: { xs: '50%', md: 50 },
         transform: { xs: 'translateX(-50%)', md: 'none' },
         zIndex: 1001,
         pointerEvents: 'auto'
       }}
     >
       <Box
         sx={{
           position: 'relative',
           display: 'inline-block',
           padding: isDark ? '4px' : '4px',
           borderRadius: 2,
           backgroundColor: isDark ? 'rgba(255, 255, 255, 0.08)' : 'rgba(255, 255, 255, 0.04)',
           backdropFilter: isDark ? 'blur( 8px)' : 'blur(8px)',
           border: isDark ? '1px solid rgba(255, 255, 255, 0.12)' : '1px solid rgba(255, 255, 255, 0.1)',
           boxShadow: isDark 
             ? '0 4px 15px rgba(0, 0, 0, 0.25)' 
             : '0 2px 10px rgba(0, 0, 0, 0.1)',
           transition: 'all 0.3s ease-in-out',
        
         }}
       >
         <Box
           component="img"
           src={logo }
           alt={`${universityName} Logo`}
           sx={{
             height: { xs: 110, md: 100, lg: 110 },
             width: 'auto',
             objectFit: 'contain',
             maxWidth: { xs: '200px', md: '220px', lg: '240px' },
             display: 'block',
             filter: isDark 
               ? 'brightness(1.3) contrast(1.05) drop-shadow(0 1px 4px rgba(255,255,255,0.1))' 
               : 'brightness(1.02) contrast(1.01) drop-shadow(0 1px 2px rgba(0,0,0,0.12))',
             transition: 'filter 0.3s ease-in-out',
             backgroundColor: isDark ? 'rgba(255, 255, 255, 0.88)' : 'transparent',
             borderRadius: isDark ? 2 : '0',
            padding: isDark ? '4px' : '4px',
           
           }}
           onError={(e) => {
             e.currentTarget.style.display = 'none';
           }}
         />
       </Box>
     </Box>
   </motion.div>
 );
};

export default TopLogo;